import {action, observable} from 'mobx'

import * as Type from '../../constant/ProfileCatalogEntityType'

export default class CatalogEntity {
    @observable type = Type.CATEGORY
    /** @type {Array<*>} */
    @observable ids = []

    /** @type {Map<*, boolean>} вспомогательная переменная для выбора */
    @observable _selected_ids = new Map()

    constructor(e) {
        if (e) {
            this.type = e.type
            this.ids = [...e.ids]

            this._selected_ids = new Map(
                this.ids.map(id => [
                    this.type === Type.PRODUCTS_SET ? id : parseInt(id), true
                ])
            )
        }
    }

    @action setType(type) {
        this.type = type

        this.ids = []
        this._selected_ids.clear()
    }

    @action toggle(entity_id, toggle) {
        if (this.type !== Type.PRODUCTS_SET) {
            entity_id = parseInt(entity_id)

            if (isNaN(entity_id)) {
                return
            }
        }

        if (toggle) {
            this._selected_ids.set(entity_id, true)
        } else {
            this._selected_ids.delete(entity_id)
        }

        this.ids = Array.from(this._selected_ids.keys())
    }

    isSelected(entity_id) {
        if (this.type !== Type.PRODUCTS_SET) {
            entity_id = parseInt(entity_id)
        }

        return this._selected_ids.has(entity_id)
    }
}
